import React from 'react';
import { useIntl } from 'react-intl';
import classNames from 'classnames/bind';

import useOrderTracking from '../useOrderTracking';

// Components
import Heading from '../../../components/Heading';
import Button from '../../../components/Button';
import Container from '../../../components/Container';
import Steps from '../Steps/DesktopView';
import Map from '../Map/DesktopView';
import Cart from '../Cart/DesktopView';

// Router
import { getRoute } from '../../../entry/routes';

// Styles
import styles from './OrderTracking.styl';

const cx = classNames.bind(styles);

export default function OrderTrackingPage() {
  const intl = useIntl();

  const { orderData, seo, getOrderStatus } = useOrderTracking();

  // const [isOpen, setIsOpen] = useState(false);
  //
  // useEffect(() => {
  //   const redirect = sessionStorage.getItem('marketRedirect');
  //   !redirect && setIsOpen(true);
  // }, []);

  return (
    <>
      {seo}
      <Container className={cx('OrderTracking')}>
        <div className={cx('OrderTracking__main')}>
          <Heading className={cx('OrderTracking__title')} level={3}>
            {intl.formatMessage({ id: 'thanksForOrdering.title' })}
          </Heading>
          {orderData ? (
            <>
              <Steps orderData={orderData} />
              <Map orderData={orderData} getOrderStatus={getOrderStatus} />
            </>
          ) : (
            <div className={cx('OrderTracking__spinner')} />
          )}
        </div>
        {orderData && <Cart orderData={orderData} />}
        <Button className={cx('OrderTracking__button')} to={getRoute('home')}>
          {intl.formatMessage({ id: 'page.orderStatus.button' })}
        </Button>
      </Container>
      {/*{isOpen && <RedirectModal isOpen={isOpen} onClose={() => setIsOpen(false)} />}*/}
    </>
  );
}
